import Carousel from './reducer';

export default Carousel;
